<script setup lang="ts">
import { inject, ref } from "vue";

const { news } = defineProps({
    news: {
        type: Array,
        required: true,
    },
});

const sliderEl = ref<JQLite>();
</script>
<template>
    <div class="col-start-3 col-end-23 home-news-slider-wrapper">
        <div
            class="slider-simple"
            ref="sliderEl"
            data-responsive='[
                {
                    "breakpoint": 9999,
                    "settings": {
							"slidesToShow": 3
                    }
                },
                {
                    "breakpoint": 1401,
                    "settings": {
						 "slidesToShow": 3
                    }
                },
                {
                    "breakpoint": 1201,
                    "settings": {
                        "slidesToShow": 2
                    }
                },
                {
                    "breakpoint": 769,
                    "settings": {
                        "slidesToShow": 1
                    }
                },
                {
                    "breakpoint": 501,
                    "settings": {
                        "slidesToShow": 1
                    }
                }
            ]'
        >
            <div v-for="newsEntry in news" class="home-news-cell">
                <a
                    class="home-news-link"
                    :class="'category-' + newsEntry.category"
                    :href="newsEntry.url"
                >
                    <div
                        class="corner-tag"
                        :style="'background:' + newsEntry.color"
                        v-if="newsEntry.categoryShortname"
                    >
                        <span class="tag">{{
                            newsEntry.categoryShortname
                        }}</span>
                    </div>

                    <div class="home-news-body">
                        <img
                            class=""
                            :src="newsEntry.mainImage"
                            :alt="newsEntry.title"
                        />

                        <div
                            class="news-category"
                            :style="'background:' + newsEntry.color"
                        >
                            {{ newsEntry.category }}
                        </div>

                        <div class="news-title">{{ newsEntry.title }}</div>
                        <div class="news-lead">{{ newsEntry.lead }}</div>
                    </div>

                    <div class="home-news-learnmore">
                        Learn more
                        <i class="fas fa-arrow-right"></i>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
